import { ContractNoticeComponentView } from '../ContractNoticeComponentView';
import { WprBaseViewModeInfo } from '../../../wpr-framework/mode/WprBaseViewMode';
import { WprDI_Control } from '../../../wpr-framework/view/di/WprDI_Control';
import { WprControlInfo } from '../../../wpr-framework/view/control/WprControlInfo';
import { WprDI_Object } from '../../../wpr-framework/view/di/WprDI_Object';

/**
 * 告知事項モード
 */
export class ContractNoticeMode extends WprBaseViewModeInfo<ContractNoticeComponentView>{
	// DI情報  ------------------------------------------------------------------
	@WprDI_Control
	private m_Answer: WprControlInfo 	= null;		// 謝絶承諾処理ボタン
	@WprDI_Object
	private m_PdfFlg: boolean = false;		// PDFダウンロードボタン
	// --------------------------------------------------------------------------
	
	// コンストラクタ  -----------------------------------------------------------
	public constructor() {
		super('contractNoticeMode');
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * モードリスト取得（この画面モードで使用する全てのモードを定義する）
	 * @param list モードリスト
	 */
	public useModeList(list: string[]): void {
		list.push('活性');
		list.push('非活性');
	}

	/**
	 * フィールド定義を登録処理
	 */
	public onRegisterControl(): void{
		this.addControl('answer', { check: true });
		this.addControl('next', { enabled: [{ mode: '非活性', value: false}, { mode: 'other', value: true},],});
	}

	/**
	 * 画面の状態をチェックしてモードを変更する
	 * @param curMode 現在のモード
	 * @return 新しいモード（変更ない場合は現在のモード）
	 */
	public onCheckMode(curMode: string): string {
		if (this.m_Answer.value === '' || this.m_PdfFlg === false)
			return '非活性';
		return '活性';
	}
	// --------------------------------------------------------------------------
}